<template>
<div class="container">

  <!-- Outer Row -->
  <div class="row justify-content-center">

    <div class="col-xl-10 col-lg-12 col-md-9">

      <div class="card o-hidden border-0 shadow-lg my-5">
        <div class="card-body p-0">
          <!-- Nested Row within Card Body -->
          <div class="row">
            <div class="col-lg-5 d-none d-lg-block bg-login-image" v-bind:style="{ background: 'url(' + imgSrc + ')', backgroundPosition: 'center', backgroundSize: 'cover' }"></div>
            <div class="col-lg-7">
              <div class="p-5">
                <div class="text-center">
                  <h1 class="h4 text-gray-900 mb-4">Créer un compte</h1>
                </div>
                <b-form class="user">
                  <div class="form-group row">
                    <div class="col-sm-6 mb-3 mb-sm-0">
                      <b-form-input v-model="firstname" type="text" required placeholder="Prénom" class="form-control-user" :class="{'is-invalid': $v.firstname.$error}" ></b-form-input>
                    </div>
                    <div class="col-sm-6">
                      <b-form-input v-model="lastname" type="text" required placeholder="Nom" class="form-control-user" :class="{'is-invalid': $v.lastname.$error}"></b-form-input>
                    </div>
                  </div>
                  <div class="form-group">
                    <b-form-input v-model="email" type="email" required placeholder="Email" class="form-control-user" :class="{'is-invalid': $v.email.$error}"></b-form-input>
                  </div>
                  <div class="form-group row">
                    <div class="col-sm-6 mb-3 mb-sm-0">
                      <b-form-input v-model="password" type="password" required placeholder="Mot de passe" class="form-control-user" :class="{'is-invalid': $v.password.$error}"></b-form-input>
                    </div>
                    <div class="col-sm-6">
                      <b-form-input v-model="repassword" type="password" required placeholder="Confirmer le mot de passe" class="form-control-user"  :class="{'is-invalid': $v.repassword.$error}"></b-form-input>
                    </div>
                  </div>
                  <b-button type="button" variant="primary" class="btn-user btn-block" @click.prevent="register">
                    <i v-if="submitStatus == 'pending'" class="fas fa-circle-notch fa-spin"></i>
                    <span v-else>S'enregistrer</span>
                  </b-button>
                </b-form>
                <hr>
                <div class="text-center">
                  <a class="small" href="forgot-password.html">Mot de passe perdu ?</a>
                </div>
                <div class="text-center">
                  <a class="small" href="/">Déjà un compte ? se connecter</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

  </div>
</div>
</template>

<script>
  import { required, minLength, email, sameAs } from "vuelidate/lib/validators"
  import axios from 'axios'

  export default {
    name: 'login',
    data() {
      return {
        email: '',
        password: '',
        repassword: '',
        firstname: '',
        lastname: '',
        errors: false,
        empty: true,
        submitStatus: '',
        hasError: false,
        imgSrc: require('@/assets/homebg.png'),
      }
    },
    validations: {
      firstname: {
        required
      },
      lastname: {
        required
      },
      email: {
        required,
        email
      },
      password: {
        required,
      },
      repassword: {
        required,
        sameAsPassword: sameAs("password")
      }
    },
    methods: {
      register: function() {
        if(this.submitStatus != "pending") {
          this.inputErrors = []
          this.submitStatus = "pending"

          this.$v.$touch()
          if (this.$v.$invalid) {
            console.log("error")
            this.submitStatus = ''
          } else {
            let account = {
              firstname: this.firstname,
              lastname: this.lastname,
              email: this.email.toLowerCase(),
              password: this.password,
              repassword: this.repassword,
            }
            this.$store
              .dispatch('register', account)
              .then((e) => {

              })
              .catch(err => {
                this.hasError = true
                this.submitStatus = ''
              })
          }

        }

      },
      toggleBodyClass(addRemoveClass, className) {
        const el = document.body;
        if (addRemoveClass === 'addClass') {
          el.classList.add(className);
        } else {
          el.classList.remove(className);
        }
      },
    },
    mounted() {
      this.toggleBodyClass('addClass', 'bg-login');
    },
    destroyed() {
      this.toggleBodyClass('removeClass', 'bg-login');
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/Register.vue